var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97.2 97.2",
    style: {
      enableBackground: "new 0 0 97.2 97.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414042;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.6,4.8C24.4,4.8,4.8,24.4,4.8,48.6s19.7,43.8,43.8,43.8s43.8-19.7,43.8-43.8S72.8,4.8,48.6,4.8z M48.6,83 c-19,0-34.4-15.5-34.4-34.4s15.5-34.4,34.4-34.4S83,29.7,83,48.6S67.6,83,48.6,83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.4,47.2H51.8V23.5c0-2-1.6-3.6-3.6-3.6c-2,0-3.6,1.6-3.6,3.6v27.3c0,2,1.6,3.6,3.6,3.6h23.3 c2,0,3.6-1.6,3.6-3.6C75,48.9,73.4,47.2,71.4,47.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/timeIcon.0b77cf60044b0bd166ff0c7b77d3d29d.svg";
export { ForwardRef as ReactComponent };